import { Box, useTheme } from "@mui/material";

export function ContactEditorButtons({...params}){

    let toggleModal = params.toggleModal
    let confirmationScreenState = params.confirmationScreenState
    let setConfirmationScreenState = params.setConfirmationScreenState
    let saveButtonDisabled = params.saveButtonDisabled
    let setSaveButtonDisabled = params.setSaveButtonDisabled
    let input = params.input
    let setInput = params.setInput
    let isNewContact = params.isNewContact
    let handleContactChange = params.handleContactChange
    let theme = useTheme()

    function removeButtonOnClick(){
        if (!confirmationScreenState) setConfirmationScreenState(true)
        else if (confirmationScreenState){ 
            handleContactChange('remove', input)
            setConfirmationScreenState(false)
            setSaveButtonDisabled(true)
            toggleModal()
        }
    }

    const RemoveButton = () => {
        let buttonColor = ''
        if (confirmationScreenState) buttonColor = '#9D0606'
        else if (!confirmationScreenState) buttonColor = '#06569D'
        return (
            <Box borderRadius={0} backgroundColor={buttonColor} padding={"5px 30px"} fontSize={"18px"} textTransform={"none"} boxShadow={"none"} onClick={removeButtonOnClick}>
                {'Remove Contact'}
            </Box>
        )
    };

    function cancelButtonOnClick(){
        setConfirmationScreenState(false)
        setSaveButtonDisabled(true)
        toggleModal()
        setInput({name: '', email: ''})
    }

    const CancelButton = () => {
        return (
            <Box borderRadius={0} backgroundColor={"#06569D"} padding={"5px 30px"} fontSize={"18px"} textTransform={"none"} boxShadow={"none"} onClick={cancelButtonOnClick}>
                {'Cancel'}
            </Box>
        )
    };

    function saveButtonOnClick(changeType, input){
        if (saveButtonDisabled) return
        handleContactChange(changeType, input)
        setConfirmationScreenState(false)
        setSaveButtonDisabled(true)
        toggleModal()
    }

    const SaveButton = () => {
        let buttonColor = ''
        let buttonOpacity = '100%'
        if (saveButtonDisabled) {
            buttonColor = theme.palette.ContactEditor.gray
            buttonOpacity = '50%'
        }
        else if (!saveButtonDisabled) buttonColor = '#06569D'

        let changeType = ''
        if (isNewContact) changeType = 'add'
        else if (!isNewContact) changeType = 'edit'
        return (
            <Box borderRadius={0} sx={{backgroundColor: buttonColor, opacity: buttonOpacity}} padding={"5px 30px"} fontSize={"18px"} textTransform={"none"} boxShadow={"none"} onClick={() => saveButtonOnClick(changeType, input)}>
                {'Save'}
            </Box>
        )
    };

    if (isNewContact){
        return(
            <Box id="contactEditorButtonBox" position={'absolute'} bottom={'32px'} left={'138px'} display="flex" alignContent="center" gap={2}>
                <CancelButton/>
                <SaveButton/>
            </Box>
        )
    }

    else if (!isNewContact && confirmationScreenState){
        return(
            <Box id="contactEditorButtonBox" position={'absolute'} bottom={'32px'} left={'89px'} display="flex" alignContent="center" gap={2}>
                <RemoveButton />
                <CancelButton/>
            </Box>
        )
    }

    else if (!isNewContact){
        return(
            <Box id="contactEditorButtonBox" position={'absolute'} bottom={'32px'} left={'36.5px'} display="flex" alignContent="center" gap={2}>
                <RemoveButton />
                <CancelButton/>
                <SaveButton/>
            </Box>
        )
    }
}
